function Slide ($items, opts) {
    opts = opts || {};

    this.timer = 0;
    this.index = 0;
    this.$items = $items;
    this.duration = opts.duration || 3000;
    this.onChange = opts.onChange || $.noop;
    this.change(0);
}

Slide.prototype = {
    contructor: Slide,

    interval: function interval () {
        var _this = this;

        this.timer = setTimeout(function () {
            _this._change(++_this.index);
            interval.call(_this);
        }, _this.duration);
    },

    _change: function (type) {
        if (typeof type === 'string') {
            type === 'last' ? this.index-- : this.index++;
        } else {
            this.index = type;
        }

        if (this.index < 0) {
            this.index = this.$items.length - 1;
        } else if (this.index > this.$items.length - 1) {
            this.index = 0;
        }

        this.$items.stop().fadeOut().eq(this.index).fadeIn();
        this.onChange(this.index);
    },

    change: function (type) {
        clearTimeout(this.timer);
        this._change(type);
        this.interval();
    }
};

module.exports = Slide;



//////////////////
// WEBPACK FOOTER
// ./pages/anniversary/js/slide.js
// module id = 3
// module chunks = 0 2